
import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { cn } from '@/lib/utils';

function StartNode({ data }: { data: any }) {
  return (
    <div className={cn(
      "px-4 py-2 shadow-md rounded-md border-2 border-green-500 bg-green-50",
      "min-w-[150px] text-center"
    )}>
      <div className="font-bold">{data.label}</div>
      <Handle 
        type="source" 
        position={Position.Bottom} 
        className="w-3 h-3 bg-green-500" 
      />
    </div>
  );
}

export default memo(StartNode);
